import React from 'react';
import { createPortal } from 'react-dom';

/**
 * Shared chrome for the hand-rolled full-screen capture/scan overlays
 * (WebcamCapture, VideoRecorder, IstamaraScanner, VINBarcodeScanner, ...).
 * Portals to <body> so the fixed-position overlay escapes any transformed
 * ancestor (e.g. a Headless UI modal panel), and renders the outer
 * `fixed inset-0` backdrop. Everything inside (header, controls, close
 * logic, animation) stays owned by the caller.
 *
 * Props: zClassName (default 'z-50'), bgClassName (default 'bg-black'),
 * className (extra classes appended after bgClassName).
 */
const FullScreenOverlay = ({ zClassName = 'z-50', bgClassName = 'bg-black', className = '', children }) => {
  return createPortal(
    <div className={['fixed inset-0', zClassName, bgClassName, className].filter(Boolean).join(' ')}>
      {children}
    </div>,
    document.body
  );
};

export default FullScreenOverlay;
